export default {"src":"/_next/static/media/10Bet.3e6bfc55.svg","height":200,"width":400,"blurWidth":0,"blurHeight":0};